<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- hasSentPreviousMsg -->
<template>
  <div id="visualizer">
    <!-- <pre>{{artefact}}</pre> -->
    <div v-if="['SSO'].includes(artefact.type)">
      <mock :artefact="artefact" :key="artefact.query"></mock>
    </div>
  </div>
</template>

<script>

import Mock from "./Mock.vue";
import {fetchMock} from "../shared/services";

export default {
  props: {
    artefact: { type: Object, required: true }
  },
  data() {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {

  },
  mounted() {

  },
  components: {
    Mock
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
#visualizer {
  .tagger {
    padding: 0.5rem 1rem;
    border-radius: 25px;
    margin-right: 1rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
  .tasks-today-container {
    .tasks-today__task {
      transition: background 0.15s ease-out;
      .tasks-today__actions {
        display: none;
      }

      &:hover {
        background: rgba(var(--vs-primary), 0.04);
        .tasks-today__actions {
          display: flex;
        }
      }
    }
  }

  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
